// Auto-generated Node.js components map

import Node_AdvTS from "./nodejs_components/Node_AdvTS.jsx";
import Node_Architecture from "./nodejs_components/Node_Architecture.jsx";
import Node_Assert from "./nodejs_components/Node_Assert.jsx";
import Node_Async from "./nodejs_components/Node_Async.jsx";
import Node_AsyncAwait from "./nodejs_components/Node_AsyncAwait.jsx";
import Node_Auth from "./nodejs_components/Node_Auth.jsx";
import Node_Buffer from "./nodejs_components/Node_Buffer.jsx";
import Node_CmdLine from "./nodejs_components/Node_CmdLine.jsx";
import Node_Crypto from "./nodejs_components/Node_Crypto.jsx";
import Node_DNS from "./nodejs_components/Node_DNS.jsx";
import Node_ES6 from "./nodejs_components/Node_ES6.jsx";
import Node_ESModules from "./nodejs_components/Node_ESModules.jsx";
import Node_Errors from "./nodejs_components/Node_Errors.jsx";
import Node_EventLoop from "./nodejs_components/Node_EventLoop.jsx";
import Node_Events from "./nodejs_components/Node_Events.jsx";
import Node_Express from "./nodejs_components/Node_Express.jsx";
import Node_FS from "./nodejs_components/Node_FS.jsx";
import Node_Frameworks from "./nodejs_components/Node_Frameworks.jsx";
import Node_Frontend from "./nodejs_components/Node_Frontend.jsx";
import Node_GetStarted from "./nodejs_components/Node_GetStarted.jsx";
import Node_HTTP from "./nodejs_components/Node_HTTP.jsx";
import Node_HTTPS from "./nodejs_components/Node_HTTPS.jsx";
import Node_Home from "./nodejs_components/Node_Home.jsx";
import Node_Intro from "./nodejs_components/Node_Intro.jsx";
import Node_Lint from "./nodejs_components/Node_Lint.jsx";
import Node_ManageDep from "./nodejs_components/Node_ManageDep.jsx";
import Node_Middleware from "./nodejs_components/Node_Middleware.jsx";
import Node_Modules from "./nodejs_components/Node_Modules.jsx";
import Node_NPM from "./nodejs_components/Node_NPM.jsx";
import Node_NpmScripts from "./nodejs_components/Node_NpmScripts.jsx";
import Node_OS from "./nodejs_components/Node_OS.jsx";
import Node_PackageJson from "./nodejs_components/Node_PackageJson.jsx";
import Node_Path from "./nodejs_components/Node_Path.jsx";
import Node_Process from "./nodejs_components/Node_Process.jsx";
import Node_Promises from "./nodejs_components/Node_Promises.jsx";
import Node_PublishPackages from "./nodejs_components/Node_PublishPackages.jsx";
import Node_RESTAPI from "./nodejs_components/Node_RESTAPI.jsx";
import Node_Readline from "./nodejs_components/Node_Readline.jsx";
import Node_Requirements from "./nodejs_components/Node_Requirements.jsx";
import Node_Stream from "./nodejs_components/Node_Stream.jsx";
import Node_TS from "./nodejs_components/Node_TS.jsx";
import Node_Timers from "./nodejs_components/Node_Timers.jsx";
import Node_URL from "./nodejs_components/Node_URL.jsx";
import Node_Util from "./nodejs_components/Node_Util.jsx";
import Node_V8Engine from "./nodejs_components/Node_V8Engine.jsx";
import Node_VsBrowser from "./nodejs_components/Node_VsBrowser.jsx";

const NodejsComponentsMap = {
  "<Node_AdvTS />": Node_AdvTS,
  "<Node_Architecture />": Node_Architecture,
  "<Node_Assert />": Node_Assert,
  "<Node_Async />": Node_Async,
  "<Node_AsyncAwait />": Node_AsyncAwait,
  "<Node_Auth />": Node_Auth,
  "<Node_Buffer />": Node_Buffer,
  "<Node_CmdLine />": Node_CmdLine,
  "<Node_Crypto />": Node_Crypto,
  "<Node_DNS />": Node_DNS,
  "<Node_ES6 />": Node_ES6,
  "<Node_ESModules />": Node_ESModules,
  "<Node_Errors />": Node_Errors,
  "<Node_EventLoop />": Node_EventLoop,
  "<Node_Events />": Node_Events,
  "<Node_Express />": Node_Express,
  "<Node_FS />": Node_FS,
  "<Node_Frameworks />": Node_Frameworks,
  "<Node_Frontend />": Node_Frontend,
  "<Node_GetStarted />": Node_GetStarted,
  "<Node_HTTP />": Node_HTTP,
  "<Node_HTTPS />": Node_HTTPS,
  "<Node_Home />": Node_Home,
  "<Node_Intro />": Node_Intro,
  "<Node_Lint />": Node_Lint,
  "<Node_ManageDep />": Node_ManageDep,
  "<Node_Middleware />": Node_Middleware,
  "<Node_Modules />": Node_Modules,
  "<Node_NPM />": Node_NPM,
  "<Node_NpmScripts />": Node_NpmScripts,
  "<Node_OS />": Node_OS,
  "<Node_PackageJson />": Node_PackageJson,
  "<Node_Path />": Node_Path,
  "<Node_Process />": Node_Process,
  "<Node_Promises />": Node_Promises,
  "<Node_PublishPackages />": Node_PublishPackages,
  "<Node_RESTAPI />": Node_RESTAPI,
  "<Node_Readline />": Node_Readline,
  "<Node_Requirements />": Node_Requirements,
  "<Node_Stream />": Node_Stream,
  "<Node_TS />": Node_TS,
  "<Node_Timers />": Node_Timers,
  "<Node_URL />": Node_URL,
  "<Node_Util />": Node_Util,
  "<Node_V8Engine />": Node_V8Engine,
  "<Node_VsBrowser />": Node_VsBrowser,
};

export default NodejsComponentsMap;
